/*
 * Copyright 2017 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/**
 * @module Serializer
 */

import {SerializerBase} from '../SerializerBase';

type SerializedData = {
  type: 'Uint32Array' | 'Uint16Array' | 'Uint8Array';
  buffer: Array<number>;
};

export class ArrayBufferSerializer extends SerializerBase<
  ArrayBuffer,
  SerializedData
> {
  get classToSerialize() {
    return ArrayBuffer;
  }

  serialize(e: ArrayBuffer): SerializedData {
    if (e.byteLength % 4 === 0) {
      return {
        type: 'Uint32Array',
        buffer: Array.from(new Uint32Array(e)),
      };
    } else if (e.byteLength % 2 === 0) {
      return {
        type: 'Uint16Array',
        buffer: Array.from(new Uint16Array(e)),
      };
    } else {
      return {
        type: 'Uint8Array',
        buffer: Array.from(new Uint8Array(e)),
      };
    }
  }

  deserialize(e: SerializedData) {
    switch (e.type) {
      case 'Uint8Array': {
        return Uint8Array.from(e.buffer).buffer;
      }
      case 'Uint16Array': {
        return Uint16Array.from(e.buffer).buffer;
      }
      case 'Uint32Array': {
        return Uint32Array.from(e.buffer).buffer;
      }
    }
  }
}
